/**
 * /tenants/$slug/devices — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  devicesListSearchSchema,
  type DevicesListSearch,
} from "@/features/devices/schemas";
import { fetchDevices } from "@/features/devices/queries";
import { queryKeys } from "@/lib/query-keys";
import { DevicesPage } from "@/features/devices/pages/devices-page";

export const Route = createFileRoute("/_authed/tenants/$slug/devices/")({
  validateSearch: (raw: Record<string, unknown>): DevicesListSearch =>
    devicesListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.devices.list(context.tenant.id, deps.search),
      queryFn: () => fetchDevices(context.tenant.id, deps.search),
    }),
  component: DevicesPage,
});
